const _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"9eb848ba2ced0ed820e21fd2fb68521c27862325"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["gardens@1hive-6w"]={id:"9eb848ba2ced0ed820e21fd2fb68521c27862325"};
      